import Vue from "vue";
import BaseService from "./base";

const ArchiveService = {

    base: BaseService.base,
    sortMap: {
        date: 'unit_dates',
        title: 'title',
        person: 'names',
        number: 'accession_num',
        call_num: 'holdings.call_num',
        service: 'military.service'
    },

    /**
     * Retrieve all of Archives
     * @param {*} lang The language, either `en` or `fr`
     */
    all(lang) {
        return Vue.axios.get(`${this.base()}/${lang}/collections/archive`)
            .catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

    /**
     * Retrieve an Archive detail
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} slug
     */
    detail(lang, id) {
        return Vue.axios.get(`${this.base()}/${lang}/collections/archive/${id}`)
            .catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

    /**
     * Search an Archive field by the provided token
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} query
     * @param {*} sort
     * @param {*} order
     * @param {*} page
     * @param {*} size
     */
    search(lang, query, sort, order='asc', page=1, size=30, output='small') {
        var endpoint = `${this.base()}/_search/`;

        return Vue.axios.post(endpoint,
            {
                lang: lang,
                site: "collections",
                type: "archive",
                terms: query,
                sort: this.sortMap[sort],
                order: order,
                page: page,
                size: size,
                output: output
            }
            ).catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

    
    /**
     * Get a count of archives that satisfy a query
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} query
     * @param {*} sort
     * @param {*} order
     * @param {*} page
     * @param {*} size
     */
     count(lang, query, sort, order='asc', page=1, size=30) {
        //  TODO use count api endpoint
        var endpoint = `${this.base()}/_search/`;

        return Vue.axios.post(endpoint,
            {
                lang: lang,
                site: "collections",
                type: "archive",
                terms: query,
                sort: this.sortMap[sort],
                order: order,
                page: page,
                size: size,
                output: 'min'
            }
            ).catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },
};

export default ArchiveService;
